fragment WidgetFragment on Widget {
    id
    name
    type
    isCollapsedForUser
    isHidden
    location
    position
    isDisabledByAdmin
}
